// extracted by mini-css-extract-plugin
export default {"Title":"ComparisonGettingStarted_Title__2G1Jt","SampleBtnWrapper":"ComparisonGettingStarted_SampleBtnWrapper__B-5Pu"};